export function mergeObjects(obj1, obj2) {
    const obj3 = {};
    let attrname;
    for (attrname in obj1) {
        obj3[attrname] = obj1[attrname];
    }
    for (attrname in obj2) {
        obj3[attrname] = obj2[attrname];
    }
    return obj3;
}

export function iCoreForEach(arr, callback, onDoneCallback) {
    // in case arr is an empty query selector node list
    if (arr) {
        for (let i = 0, len = arr.length; i < len; i++) {
            callback(arr[i], i);
        }
    }

    if (typeof onDoneCallback === "function") {
        onDoneCallback();
    }
}